<script>
  import { fade } from 'svelte/transition';
  import { AppController } from '../AppController';
  import { form } from '../validate.js';
  import { showLoading } from '../components/Overlay.svelte';
  import { toast, stickyToast, clearToasts } from '../components/Toast.svelte';

  const credentials = {
    email: ''
  }

  const { validate, ...signInForm } = form(() => ({
    email: { value: credentials.email, validators: ["required", "email"]},
  }));

  const reset = async () => {
    try {
      clearToasts();
      showLoading(true);
      await AppController.resetPassword(credentials.email);
      toast('success', 10000, 'Password Reset', 'Password has been reset for the email address provided. A temporary password has been emailed to you. Please allow up to 5 minutes for email to be received.');
    } catch (err) {
      stickyToast('danger', 'Error', 'Error resetting password. Please contact Public Alert Support.');
      console.log(err);
    } finally {
      showLoading(false);
    }
  }
</script>

<div class="container-scroller" in:fade="{{duration: 1000}}">
  <div class="container-fluid page-body-wrapper full-page-wrapper">
    <div class="content-wrapper d-flex align-items-center auth px-0">
      <div class="row w-100 mx-0">
        <div class="col-lg-4 mx-auto">
          <div class="auth-form-light text-left py-5 px-4 px-sm-5">
            <div class="brand-logo">
              <img src="../../images/public_alert_logo2.jpg" alt="logo">
            </div>
            <h4>Password Reset</h4>
            <h6 class="font-weight-light">Enter email address</h6>
            <form class="pt-3">
              <div class="form-group">
                <input 
                  type="email" 
                  class="form-control form-control-lg"
                  class:border-danger={!$signInForm.email.valid && $signInForm.email.dirty}
                  id="exampleInputEmail1" 
                  placeholder="Email"
                  bind:value={credentials.email}
                  use:validate={credentials.email}
                  >
                  {#if ($signInForm.email.errors.includes('required') || 
                        $signInForm.email.errors.includes('email')) &&
                        $signInForm.email.dirty}
                    <p class='text-danger text-small'>Email is required</p>
                  {/if}
              </div>
   
              <div class="mt-3">
                <button 
                  class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" 
                  on:click|preventDefault={reset} 
                  class:disabled={!$signInForm.valid} 
                  disabled={!$signInForm.valid}>
                    RESET
                  </button>
              </div>
              <div class="my-2 d-flex justify-content-between align-items-center">
                <a href="#/login" class="auth-link text-black">Back to login</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- content-wrapper ends -->
  </div>
  <!-- page-body-wrapper ends -->
</div>